<template>
    <div class="calendar_modal_box">
        <b-modal ref="modal" @hide="hide" id="calendar_modal" title="開課日期搜尋" hide-footer centered>
            <div class="calendar_content">
                <div class="date_box mb-2">
                    <datepicker @changedYear="changedYear" @changedMonth="changedMonth" @selected="chooseDate"
                        :inline="true" v-model="selectedDate" :highlighted="highlightedFn"
                        :disabledDates="disabledDates" :open-date="new Date()"></datepicker>
                </div>
                <h6 class="text-center mb-3">依點選日期往後列出{{ queryDay }}天內的開課課程</h6>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {
        mapActions
    } from 'vuex'
    import Datepicker from 'vuejs-datepicker'
    import classApi from '@/api/class'
    import moment from 'moment'
    import _ from 'lodash';

    export default {
        name: 'CalendarModal',
        data() {
            return {
                date: new Date(),
                queryDay: 7,
                selectedDate: null,
                disabledDates: {
                    to: new Date(Date.now() - 8640000)
                },
                highlightedFn: {
                    dates: [],
                },
            }
        },
        components: {
            Datepicker,
        },
        created() {
            this.getCalendar();
        },
        methods: {
            ...mapActions('student', [
                'hide',
            ]),
            changedYear(date) {
                // eslint-disable-next-line
                console.log(date)
            },
            changedMonth(date) {
                // console.log(date)
                if (date == undefined) {
                    date = this.date;
                }
                if (!(date instanceof Date)) {
                    let timestamp = _.get(date, 'timestamp');

                    if (timestamp) {
                        date = moment(timestamp).format("YYYY/MM/DD");
                    } else {
                        date = null;
                    }
                }
                if (date != null) {
                    this.getCalendar(moment(date).startOf('month').format('YYYY/MM/DD'));
                } else {
                    this.getCalendar();
                }
            },
            chooseDate(date) {
                date = moment(date).format('YYYY/MM/DD');

                this.$refs.modal.hide()
                this.date = new Date();
                this.$router.push({
                    name: 'calendar',
                    query: {
                        date: date
                    }
                })
                // this.$router.push({ name: 'calendar', query: { year: date.getFullYear(),month: date.getMonth() + 1, day: date.getDate() } })
            },
            getCalendar(date) {
                if (date == undefined) {
                    date = moment().startOf('month').format('YYYY/MM/DD');
                }

                let QueryMonth = date;
                console.log(QueryMonth)
                classApi.dateSearch({
                    QueryMonth,
                }, (data) => {
                    if (data) {
                        // this.highlightedFn.dates = [];
                        this.queryDay = data.QueryDay;
                        data.ClassdateList.forEach(element => {
                            this.highlightedFn.dates.push(new Date(element));
                        });
                    } else {
                        // this.highlightedFn.dates = [];
                        this.queryDay = 7;
                    }
                });
            },
        },
    }
</script>
<style>
.calendar_content .date_box .vdp-datepicker__calendar .day.selected {
    background: white !important;
}
</style>
